var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,40.8h4.7V22.2h27.9v18.6H44V16L25.3,8.6L6.7,16V40.8z M2.1,45.5V12.9l23.3-9.3l23.3,9.3v32.6h-14V26.8H16 v18.6H2.1z M18.4,45.5v-4.7H23v4.7H18.4z M23,38.5v-4.7h4.7v4.7H23z M27.7,45.5v-4.7h4.7v4.7H27.7z M11.4,22.2h27.9H11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepot);
export default __webpack_public_path__ + "static/media/depot.2003481ee596e6df46deee956773ad99.svg";
export { ForwardRef as ReactComponent };